var $add997722e4d4b6e$exports = {};
$add997722e4d4b6e$exports = {
    "Empty": `Tomt`
};


export {$add997722e4d4b6e$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
